import { ComponentPortal, TemplatePortal } from '@angular/cdk/portal';
import { Inject, Injectable, Injector, Optional, TemplateRef, } from '@angular/core';
import { applyPopoverConfigDefaults } from './models';
import { PopoverOutletComponent } from './popover-outlet/popover-outlet.component';
import { POPOVER_DATA, PopoverRef, popoverPositions, POPOVER_DEFAULT_CONFIG } from './util';
import * as i0 from "@angular/core";
import * as i1 from "@angular/cdk/overlay";
export class PopoverService {
    constructor(overlay, injector, defaultPopoverConfig) {
        this.overlay = overlay;
        this.injector = injector;
        this.defaultPopoverConfig = defaultPopoverConfig;
    }
    open(content, target, config = {}, viewContainerRef) {
        const popoverconfig = applyPopoverConfigDefaults(config, this.defaultPopoverConfig);
        const overlay = this.buildOverlay(popoverconfig, target);
        const attachProps = Object.assign(Object.assign({}, overlay), { popoverconfig, content, viewContainerRef });
        const popoverRef = this.attachContent(attachProps);
        return popoverRef;
    }
    buildOverlay(popoverconfig, target) {
        const popoverpositions = popoverPositions(popoverconfig);
        /** overlay strategies */
        const positionStrategy = this.overlay
            .position()
            .flexibleConnectedTo(target)
            .withPush(false)
            .withFlexibleDimensions(false)
            .withPositions(popoverpositions);
        const scrollStrategy = this.overlay.scrollStrategies.reposition();
        /** overlay ref */
        const overlayRef = this.overlay.create(Object.assign(Object.assign(Object.assign({}, popoverconfig), this.coerceMinDimensions(popoverconfig)), { positionStrategy,
            scrollStrategy }));
        return { overlayRef, positionStrategy };
    }
    attachContent(attach) {
        const { content, overlayRef, positionStrategy, popoverconfig, viewContainerRef } = attach;
        const popoverRef = new PopoverRef(overlayRef, positionStrategy, popoverconfig);
        /** outlet portal */
        const portalInjector = this.injectPopoverProviders([{ provide: PopoverRef, useValue: popoverRef }]);
        const outletPortal = new ComponentPortal(PopoverOutletComponent, null, portalInjector);
        const popover = overlayRef.attach(outletPortal).instance;
        /** content portals */
        if (content instanceof TemplateRef) {
            if (!viewContainerRef) {
                throw new Error('ViewContainerRef required for Template popover');
            }
            const templateData = { $implicit: popoverconfig.data, popover: popoverRef };
            const templatePortal = new TemplatePortal(content, viewContainerRef, templateData);
            popover.attachTemplatePortal(templatePortal);
        }
        else {
            const contentPortalInjector = this.injectPopoverProviders([
                { provide: POPOVER_DATA, useValue: popoverconfig.data },
                { provide: PopoverRef, useValue: popoverRef },
            ]);
            const componentPortal = new ComponentPortal(content, null, contentPortalInjector);
            popover.attachComponentPortal(componentPortal);
        }
        return popoverRef;
    }
    injectPopoverProviders(providers) {
        return Injector.create({ parent: this.injector, providers });
    }
    /** config utils */
    coerceMinDimensions(popoverconfig) {
        var _a;
        const diaginal = Math.sqrt(2) * ((_a = popoverconfig.arrowSize) !== null && _a !== void 0 ? _a : 0);
        let { minWidth, minHeight } = popoverconfig;
        minWidth !== null && minWidth !== void 0 ? minWidth : (minWidth = diaginal);
        minHeight !== null && minHeight !== void 0 ? minHeight : (minHeight = diaginal);
        return { minWidth, minHeight };
    }
}
PopoverService.ɵfac = function PopoverService_Factory(t) { return new (t || PopoverService)(i0.ɵɵinject(i1.Overlay), i0.ɵɵinject(i0.Injector), i0.ɵɵinject(POPOVER_DEFAULT_CONFIG, 8)); };
PopoverService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PopoverService, factory: PopoverService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PopoverService, [{
        type: Injectable
    }], function () { return [{ type: i1.Overlay }, { type: i0.Injector }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [POPOVER_DEFAULT_CONFIG]
            }] }]; }, null); })();
